import type { PropertyFormInput } from '../schemas/propertySchema'
import type { Property, StProperty } from '../types'

type StaysAddress = {
  countryCode: string
  state: string
  stateCode: string
  city: string
  region: string
  street: string
  streetNumber: string
  zip: string
}

/**
 * Get default values for property form
 */
export const getDefaultValues = (
  property?: Property | undefined | null,
  st_property?: StProperty | null
): PropertyFormInput<boolean> => {
  // console.log({ property, st_property })
  let staysAddress = null
  if (
    st_property?.address ||
    property?.stays_property?.address ||
    property?.address
  ) {
    const address = (st_property?.address ||
      property?.stays_property?.address ||
      property?.address) as StaysAddress | Property['address']

    staysAddress = {
      countryCode: 'BR',
      state: address?.state,
      stateCode: address?.stateCode,
      city: address?.city,
      region: address?.region,
      street: address?.street,
      streetNumber: address?.streetNumber,
      zip: address?.zip,
    }
  }

  const mainDefaultValues = {
    title: property?.title || '',
    address: staysAddress || {
      countryCode: 'BR',
      stateCode: '',
      city: '',
      region: '',
      street: '',
      streetNumber: '',
      zip: '',
    },
    description: property?.description || '',
    bedrooms: property?.bedrooms || 1,
    bathrooms: property?.bathrooms || 1,
    max_guests: property?.max_guests || 2,
    beds: property?.beds || 1,
    amenities: property?.amenities || [],
    wifi_name: property?.wifi_name || '',
    wifi_password: property?.wifi_password || '',
    access_code: property?.access_code || '',
    checkin_time: property?.checkin_time || '15:00',
    checkout_time: property?.checkout_time || '11:00',
    checkin_instructions: property?.checkin_instructions || '',
    checkout_instructions: property?.checkout_instructions || '',
    cleaning_fee: property?.cleaning_fee ? `${property.cleaning_fee}` : '0.00',
    management_cost_percentage: property?.management_cost_percentage
      ? `${property?.management_cost_percentage}`
      : '0.00',
    status: property?.status || 'draft',
    images:
      property?.images?.map((img) => ({
        ...img,
        is_primary: img.is_primary ?? false,
        stays_id: property?.stays_id,
      })) || [],
    main_image_index: property?.images?.findIndex((img) => img.is_primary) ?? 0,
  }

  if (st_property || property?.stays_property) {
    return {
      ...mainDefaultValues,
      _idproperty:
        st_property?.stays_id || property?.stays_property?.stays_id || '',
      listing_type: property?.listing_type || '',
      internalname: property?.st_internal_name || '',
      subtype: property?.subtype || '',
    }
  }
  // console.log({ mainDefaultValues })
  return mainDefaultValues
}
